import dayjs, { Dayjs } from 'dayjs';
import _ from 'lodash';
import { shiftDays, unixToWallClock, wallClockToUnix } from './timezone';

export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const localeFormat: string = 'sv-SE';
// const timeZone: string = 'UTC'; // @todo: Do we need to change this to a let based on users prefs as well?

// // Finding the correct localeFormat based on set country and language for the user
// // @todo: Adjust this to act based on the users' country, when we have it from the rest-api
// const findLocaleFormat = (country: string, language: string) => {
//   localeFormat = `${language}-${country}`;
// };

export const timeConverter = (unixTimestamp: number | null) => {
  if (unixTimestamp === null) {
    return null;
  }
  const a = new Date(unixTimestamp * 1000);
  const dateObject: string = a
    .toLocaleString
    /* localeFormat, {
    timeZone: timeZone,
  } */
    ();
  return dateObject;
};

export const timeConverterDate = (unixTimestamp: number | null) => {
  if (unixTimestamp === null) {
    return null;
  }
  const a = new Date(unixTimestamp * 1000);
  const dateObject: string = a.toLocaleString(localeFormat);
  return dateObject;
};

export const getLocalDisplayFormatFromTimestamp = (
  timestamp: number | null | undefined | string,
  unit = 'ms'
) => {
  if (!timestamp) return '';
  let _timestamp;
  if (typeof timestamp === 'string') {
    _timestamp = parseInt(timestamp, 10);
  } else {
    _timestamp = timestamp;
  }
  _timestamp = unit === 'sec' ? _timestamp * 1000 : _timestamp;
  return dayjs(_timestamp).format(TIME_FORMAT);
};

export const secondToHourMinute: (
  sec?: number
) => [number | undefined, number | undefined] = (sec?: number) => {
  if (sec === undefined || sec === null) return [undefined, undefined];
  return [Math.floor(sec / 3600), Math.floor(sec / 60) % 60];
};

export const hourMinuteToSecond = ([hour, min]: [
  hour?: number,
  min?: number,
]) => {
  if (
    (hour === undefined || hour === null) &&
    (min === undefined || min === null)
  )
    return undefined;
  return (hour || 0) * 3600 + (min || 0) * 60;
};

export const timeStringToSecond = (timeString: string) => {
  return timeString.split(':').reduce((acc, time) => 60 * acc + +time, 0);
};

export const secondToTimeString = (sec: number, format?: string) => {
  return dayjs()
    .startOf('day')
    .add(sec, 'second')
    .format(format || 'HH:mm:ss');
};

// Date-limit range conversion. Absolute date limits are stored as unix
// seconds at midnight in the given timezone; the end is exclusive
// (start of the day after the last included day).

/**
 * @param date - A picked date
 * @param timezone - A TZ identifier
 * @returns The picked date as a timestamp of the absolute point in time in
 * UTC, converted from `timezone`.
 */
export const dateToStartTimeUnix = (
  date: dayjs.Dayjs | null | undefined,
  timezone: string
): number | undefined =>
  date ? wallClockToUnix(date, timezone, 'startOfDay') : undefined;

/**
 * @param date - A picked date
 * @param timezone - A TZ identifier
 * @returns The day after the picked date as a timestamp of the absolute point
 * in time in UTC, converted from `timezone`.
 */
export const dateToEndTimeUnix = (
  date: dayjs.Dayjs | null | undefined,
  timezone: string
): number | undefined =>
  date
    ? wallClockToUnix(shiftDays(date, 1), timezone, 'startOfDay')
    : undefined;

/**
 * @param ts - A unix timestamp
 * @param timezone - A TZ identifier
 * @returns The day a stored start falls on in `timezone`.
 */
export const startTimeUnixToDate = (
  ts: number | undefined,
  timezone: string | undefined
): Dayjs | null => {
  if (!ts) return null;
  if (ts <= 0) return null;
  if (!timezone) return null;
  return unixToWallClock(ts, timezone, 'dayjs');
};

/**
 * @param ts - A unix timestamp
 * @param timezone - A TZ identifier
 * @returns The last included day for a stored exclusive end.
 */
export const endTimeUnixToDate = (
  ts: number | undefined,
  timezone: string | undefined
): Dayjs | null => {
  if (!ts) return null;
  if (ts <= 0) return null;
  if (!timezone) return null;
  return shiftDays(unixToWallClock(ts, timezone, 'dayjs'), -1);
};
